import { MenuTabs } from "../containers/Menu/Common/MenuTabs";
import { showError } from "../utils/errorHandler";

export const tab = (tab: string): boolean => {
  if (!(tab in MenuTabs)) {
    showError("Invalid tab. Possible values are: HISTORY | RULES | SETTINGS.");
    return false;
  }

  return true;
};

export const url = (url: string): boolean => {
  if (typeof url !== "string") {
    showError("Url has to be a string");
    return false;
  }

  return true;
};

export const tabContent = (content: string): boolean => {
  if (!(typeof content === "string" || content === null)) {
    showError("Tab content has to be a string");
    return false;
  }

  return true;
};

export const gameHistory = (value: boolean, origin?: string) => {
  if (typeof value !== "boolean") {
    showError("Game history toggle has to be a boolean", origin);
    return false;
  }

  return true;
};
